import s from "./index22.js";
import { resolveComponent as o, openBlock as m, createElementBlock as c, createVNode as n, withCtx as r, createTextVNode as u, toDisplayString as h } from "vue";
import "./index23.js";
import d from "../../../../_virtual/index.js";
const a = { class: "help-container" };
function l(e, _, i, f, w, H) {
  const t = o("csr-phone-number-component"), p = o("dropdown-menu-component");
  return m(), c("div", a, [
    n(p, {
      id: "header-help",
      menuItems: e.menuItems,
      hasArrowIcon: !0,
      showHelpCenter: e.showHelpCenter
    }, {
      title: r(() => [
        u(h(e.t("help")), 1)
      ]),
      "csr-phone-number": r(() => [
        n(t, {
          phoneNumber: e.csr.number,
          phoneHours: e.csr.hours
        }, null, 8, ["phoneNumber", "phoneHours"])
      ]),
      _: 1
    }, 8, ["menuItems", "showHelpCenter"])
  ]);
}
const $ = /* @__PURE__ */ d(s, [["render", l], ["__scopeId", "data-v-df5810f4"]]);
export {
  $ as default
};
//# sourceMappingURL=index11.js.map
